var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Man_With_Money"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Man_With_Money_1_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Man_With_Money_2_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Comparing"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Showing_Big_Size"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Afraid"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Mad"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Faint"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Winner"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Beach"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Island_On_Water"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_17"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ACC1"
    },
    d: "M24,9.604c-6.4,0-10.4,3.199-12,9.597c2.4-3.199,5.2-4.398,8.4-3.599 c1.826,0.456,3.131,1.781,4.576,3.247C27.328,21.236,30.051,24,36,24c6.4,0,10.4-3.199,12-9.598c-2.4,3.199-5.2,4.399-8.4,3.6 c-1.825-0.456-3.13-1.781-4.575-3.247C32.672,12.367,29.948,9.604,24,9.604L24,9.604z M12,24c-6.4,0-10.4,3.199-12,9.598 c2.4-3.199,5.2-4.399,8.4-3.599c1.825,0.457,3.13,1.781,4.575,3.246c2.353,2.388,5.077,5.152,11.025,5.152 c6.4,0,10.4-3.199,12-9.598c-2.4,3.199-5.2,4.399-8.4,3.599c-1.826-0.456-3.131-1.781-4.576-3.246C20.672,26.764,17.949,24,12,24 L12,24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.a37f3d5aa6889d4a00aec18765a6cb2f.svg";
export { ForwardRef as ReactComponent };